//dayjs
import dayjs from 'dayjs';
//types
import {INotification} from '../types';
//helpers
import {defineSendNotificationDay} from './time';

export const getGroupedNotificationsByDate = (data: INotification[]) => {
	return [...data]
		.sort((a, b) => dayjs(b.dateSend).valueOf() - dayjs(a.dateSend).valueOf())
		.reduce<Record<string, INotification[]>>((acc, notification) => {
			const group = defineSendNotificationDay(notification.dateSend);
			if (!acc[group]) acc[group] = [];
			acc[group].push(notification);
			return acc;
		}, {});
};
